import { isEmpty, split, isNumber, isString } from 'lodash'
import moment from 'moment'
import {effectiveArray} from './dataType'

export const getPathValue = (pathname, key) => {
    const pathArr = split(pathname, '/').filter(item => item)
    let value
    pathArr.forEach((item, index) => {
        if(item == key && isNumber(Number(pathArr[index + 1]))){
            value = Number(pathArr[index + 1])
        } 
    })
    return value
}

// 字数限制 // '赵钱孙李周吴郑王冯陈褚卫蒋沈韩杨' => '赵钱孙李周吴郑王冯陈...'
export const limitString = (target: string, length: number = 10, replace: string = '...'): string => {
    return target.length > length ? target.substring(0, length) + replace : target
}

// toThousands(54321.4567); // 54,321.4,567
export const toThousands = (num, type?) => {
    const value = (num || 0).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    if(type){
        return (type+value)
    }else{
        return value
    }
}

// 整数小数通用转化千分位
export const milliFormat = (input) => {
    return input && input.toString()
        .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// @example: toPercent(0.52355) => '52.35%'
export const toPercent = (point: any, fixed = 2): string | any => {
    const number = Number(point)
    return isNaN(number) ? point : (number * 100).toFixed(fixed) + '%'
}

export function queryToObject (query: string) {
    if (query[0] === '?') query = query.substr(1)
    return query.split('&')
    .filter(pair => pair.indexOf('=') >= 0)
    .reduce((acc: any, curr: string) => {
        const [key, value] = curr.split('=')
        acc[key] = value
        return acc
    }, {})
}


export const formatTreeData = (list, type?) => {
    if (!effectiveArray(list)) return []
    // const disList = list.filter(item => item.display != 0)
    const firstList = list.filter(item => item.pId == 0)
    
    const getChildren = (id, pName, count, info, key?) => {
        if (count >= 4 ) return []
        count++
        let onlykey = ''
        if (count > 2) {
            onlykey = key ? key : info.fieldName
        }
        return list.filter(item => item.pId == id).map(j => {
            return Object.assign({}, j, {
                title: j.name,
                key: j.id,
                parentName: pName,
                onlykey,
                isExtend: type ? type : '',
                children: getChildren(j.id, j.name, count, j, onlykey)
            })
        })
    }

    return firstList.map(item => {
        return Object.assign({}, item, {
            title: item.name,
            key: item.id,
            parentName: '',
            isExtend: type ? type : '',
            children: getChildren(item.id, item.name, 0, item)
        })
    })
}

// export const formatLeftTreeData = (list, type?) => {
//     if (!effectiveArray(list)) return []
//     // const disList = list.filter(item => item.display != 0)
//     const firstList = list.filter(item => item.pId == 0)
    
//     const getChildren = (item, key) => {
//         return list.filter(j => j.pId == item.id && j.metaId == item.metaId).map((z, index) => {
//             return Object.assign({}, z, {
//                 title: z.name,
//                 key: `${key}-${index}`,
//                 parentName: item.name,
//                 isExtend: type ? type : '',
//                 children: getChildren(z, `${key}-${index}`)
//             })
//         })
//     }

//     return firstList.map((item, index) => {
//         return Object.assign({}, item, {
//             title: item.name,
//             key: `${index}`,
//             parentName: '',
//             isExtend: type ? type : '',
//             children: getChildren(item, index)
//         })
//     })
// }

export const formatLeftTreeData = (list, type?) => {
    // console.log(list)
    if (!effectiveArray(list)) return []
    const disList = list.filter(item => item.display != 0)
    const firstList = disList.filter(item => item.pId == 0)
    
    const getChildren = (item) => {
        return list.filter(j => j.pId == item.id && j.metaId == item.metaId).map((z, index) => {
            return Object.assign({}, z, {
                title: z.name,
                key: `${item.metaId}-${z.id}`,
                parentName: item.name,
                isExtend: type ? type : '',
                children: getChildren(z)
            })
        })
    }

    return firstList.map((item, index) => {
        return Object.assign({}, item, {
            title: item.name,
            key: `${item.metaId}-${item.id}`,
            parentName: '',
            isExtend: type ? type : '',
            children: getChildren(item)
        })
    })
}

export const formatTreeDataTags = (list, type?) => {
    if (!effectiveArray(list)) return []
    // const disList = list.filter(item => item.display != 0)
    const firstList = list.filter(item => item.pId == 0)
    
    const getChildren = (id, pName, count, info, key?, value?) => {
        count++
        let onlykey = ''
        let tableFeild = ''
        if (count > 2) {
            onlykey = key ? key : info.fieldName,
            tableFeild = value ? value: info.defaultValue
        }
        return list.filter(item => item.pId == id).map(j => {
            return Object.assign({}, j, {
                title: j.treeName,
                key: j.id,
                parentName: pName,
                onlykey,
                tableFeild,
                isExtend: type ? type : '',
                children: getChildren(j.id, j.treeName, count, j, onlykey, tableFeild)
            })
        })
    }

    return firstList.map(item => {
        return Object.assign({}, item, {
            title: item.treeName,
            key: item.id,
            parentName: '',
            isExtend: type ? type : '',
            children: getChildren(item.id, item.treeName, 0, item)
        })
    })
}

// 判断data是否有子集
export const hasChildren = (dataArr)=>{
    return dataArr.map(data=>{
        if(data.lastLevel === 0){
            data.children = []
        }
        return data
    })
}

interface DateFormatOptions {
    defaultValue?: string | null | undefined;
    format?: string;
};

export function dateFormat(day: string | null, options?: DateFormatOptions) {
    const { defaultValue = '--', format = 'YYYY-MM-DD HH:mm:ss' } = options || {};
    if (!!day && isString(day)) {
        const result = moment(day).format(format);
        return result === 'Invalid date' ? defaultValue : result;
    }
    return defaultValue;
};